import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getCamp = createAsyncThunk(
  "camp/getAllCamp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "camp/getAllCamp",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getCampById = createAsyncThunk(
  "camp/getCampById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "camp/getCampById",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createCamp = createAsyncThunk(
  "camp/addCamp",
  async ({ formDataToSend, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "camp/addCamp",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCamp = createAsyncThunk(
  "camp/updateCamp",
  async ({ formDataToSend, token }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "camp/updateCamp",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCamp = createAsyncThunk(
  "camp/deleteCamp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "camp/deleteCamp",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  loading: false,
  camp: [],
  campInfo: null, 
  error: null,
  searchMessage: null,
  isLoading: false,
  createCampSuccessMessage: null,
  createCampErrorMessage: null,
  updateCampSuccessMessage: null,
  updateCampErrorMessage: null,
  deleteCampSuccessMessage: null,
  deleteCampErrorMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const campSlice = createSlice({
  name: "camp",
  initialState,
  reducers: {
    resetCreateMessages: (state) => {
      state.createCampSuccessMessage = null;
      state.createCampErrorMessage = null;
    },
    resetUpdateMessages: (state) => {
      state.updateCampSuccessMessage = null;
      state.updateCampErrorMessage = null;
    },
    resetDeleteMessages: (state) => {
      state.deleteCampSuccessMessage = null;
      state.deleteCampErrorMessage = null;
    },
    resetCampInfo: (state) => {
      state.campInfo = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCamp.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCamp.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.success) {
          state.camp = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchMessage =
            action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.camp = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })
      .addCase(getCamp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.result.message;
      })


      .addCase(getCampById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCampById.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
        } else {
          state.campInfo = action.payload.result;
        }
      })
      .addCase(getCampById.rejected, (state, action) => {
        state.loading = false;
        state.searchMessage = action.payload?.result?.message || "Failed to fetch camp by Id";
      })

      .addCase(createCamp.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createCamp.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.createCampErrorMessage = action.payload.result.message;
        } else {
          state.createCampSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(createCamp.rejected, (state, action) => {
        state.isLoading = false;
        state.createCampErrorMessage = action.payload.result.message;
      })

      .addCase(updateCamp.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCamp.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.updateCampErrorMessage = action.payload.result.message;
        } else {
          state.updateCampSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateCamp.rejected, (state, action) => {
        state.isLoading = false;
        state.updateCampErrorMessage = action.payload.result.message;
      })


      .addCase(deleteCamp.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteCamp.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.deleteCampErrorMessage = action.payload.result.message;
        } else {
          state.deleteCampSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(deleteCamp.rejected, (state, action) => {
        state.isLoading = false;
        state.deleteCampErrorMessage = action.payload.result.message;
      });
  },
});
export const { resetCreateMessages, resetUpdateMessages, resetDeleteMessages, resetCampInfo } = campSlice.actions;
export default campSlice.reducer;
